export const inputReg = new Map([
  ["num", /[^\d]/g],
  ["nozh", /\p{Script=Han}+/gu],
  ["trim", /\s+/g],
  ["noEn", /[A-Za-z]+/g],
  ["noLEn", /[a-z]+/g],
  ["noUEn", /[A-Z]+/g],
  ["noSpecial", /[^\p{Script=Han}A-Za-z0-9]+/gu],
  ["noNum", /\d+/g],
  ["idcard", /[^\dXx]/g],
  ["noWrap", /\r?\n/g]
]);
